import { render, staticRenderFns } from "./buyerPrice.vue?vue&type=template&id=a7efd542&"
import script from "./buyerPrice.vue?vue&type=script&lang=js&"
export * from "./buyerPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports